module.exports = __webpack_public_path__ + "img/79c18fa8d167e8d6fb3727cddb4335a0.14c4b3f9.png";